module.exports = __webpack_public_path__ + "static/media/twitter_logo.1cf8368a.png";